import React from 'react';
import { Popover, Button, Typography } from '@material-ui/core';

interface IProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onConfirm: () => void;
  onDelete?: () => void;
}

const UserEditDialog: React.FC<IProps> = ({ anchorEl, onClose, onConfirm, onDelete }) => {
  const open = Boolean(anchorEl);

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        style: {
          width: 200,
          // height: 199,
          backgroundColor: '#FFFFFF',
          borderRadius: 20,
          border: '1px solid #D1D5DB',
          // marginLeft: '60px',
        },
      }}
    >
      <div style={{ textAlign: 'center', alignItems: 'center' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 10,
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <Button
            style={{
              color: '#304497',
              borderRadius: 12,
              width: 100,
              height: 35,
              fontSize: 16,
            }}
            onClick={onConfirm}
          >
            Edit
          </Button>

          <Button
            style={{
              color: '#DC1F1F',
              borderRadius: 12,
              width: 100,
              height: 35,
              fontSize: 16,
            }}
            onClick={onDelete}
          >
            Delete
          </Button>
        </div>
      </div>
    </Popover>
  );
};

export default UserEditDialog;
